/* ============================================================================
   nuud US — social proof clips
   ----------------------------------------------------------------------------
   Four autoplaying videos is tens of megabytes on arrival. Instead each clip
   loads its source and starts only once it is actually on screen, and pauses
   when it leaves. Visitors who ask for reduced motion get the poster frame and
   no video at all.
   ========================================================================= */
(function () {
  'use strict';

  var reduced = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot() {
    var vids = document.querySelectorAll('[data-lazy-video]');
    if (!vids.length || reduced) return;

    if (!('IntersectionObserver' in window)) {
      // No observer: leave the posters in place rather than loading everything.
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.src) {
            v.src = v.getAttribute('data-src');
          }
          var play = v.play();
          if (play && play.catch) play.catch(function () { /* autoplay refused */ });
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '100px 0px', threshold: 0.25 });

    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  /* Review ticker on touch screens: swipeable, with the drift kept in JS.
     The track holds the list twice, so wrapping by half its width is seamless
     in both directions. Speed matches the CSS loop: half the track per
     --ticker-duration. */
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var RESUME_MS = 4000;

  function bootTicker(ticker) {
    if (ticker.dataset.touchReady) return;
    ticker.dataset.touchReady = '1';
    ticker.classList.add('ticker--touch');

    var track = ticker.querySelector('.ticker__track');
    if (!track) return;
    var duration = parseFloat(getComputedStyle(ticker).getPropertyValue('--ticker-duration')) || 90;
    var pos = 0, last = 0, held = false, resumeAt = 0, visible = false, raf = 0;

    function half() { return track.scrollWidth / 2; }
    function wrap() {
      var h = half();
      if (h <= 0) return;
      if (ticker.scrollLeft >= h) ticker.scrollLeft -= h;
      else if (ticker.scrollLeft <= 0) ticker.scrollLeft += h;
    }

    function tick(now) {
      raf = 0;
      if (!visible) return;
      var dt = last ? Math.min(now - last, 100) : 0;
      last = now;
      if (!held && now >= resumeAt && !reduced) {
        pos += (half() / duration) * (dt / 1000);
        if (pos >= half()) pos -= half();
        ticker.scrollLeft = pos;
      }
      raf = requestAnimationFrame(tick);
    }
    function start() { if (!raf) { last = 0; raf = requestAnimationFrame(tick); } }

    function hold() { held = true; }
    function release() { held = false; resumeAt = performance.now() + RESUME_MS; }

    ticker.addEventListener('touchstart', hold, { passive: true });
    ticker.addEventListener('touchend', release, { passive: true });
    ticker.addEventListener('touchcancel', release, { passive: true });
    ticker.addEventListener('scroll', function () {
      // Any scroll the drift did not cause is the visitor (a swipe, its
      // momentum after the finger lifts, a trackpad): follow it and push the
      // resume back until it settles. Our own writes land within a pixel.
      if (held || Math.abs(ticker.scrollLeft - pos) > 2) {
        wrap();
        pos = ticker.scrollLeft;
        if (!held) resumeAt = performance.now() + RESUME_MS;
      }
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start();
      }).observe(ticker);
    } else {
      visible = true; start();
    }
  }

  function bootTickers() {
    if (!coarse) return;
    Array.prototype.forEach.call(document.querySelectorAll('.ticker'), bootTicker);
  }

  function bootAll() { boot(); bootTickers(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', bootAll);
})();
